import { Assignment } from "./Assignment";
import { AssignedAssessment } from "./AssignedAssessment";

export class AssignedAssessmentGroup extends Assignment
{
    private assessmentGroupId:number|null;
    private name:string;

    public constructor() {
        super();
        this.Type = "AssessmentGroup";
    }

    public get AssessmentGroupId() : number {
        return this.assessmentGroupId;
    }
    public set AssessmentGroupId(v:number) {
        this.assessmentGroupId = v;
    }

    public getAssessmentItems() : AssignedAssessment[] {
        return this.Items.filter(i => i.Type == "Assessment").map(i => i as AssignedAssessment);
    }

    public get Name(): string {
        return this.name;
    }
    public set Name(v: string) {
        this.name = v;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/AssignedAssessmentGroup.ts